import {filter, groupBy, uniqBy, orderBy, get, minBy, maxBy, findKey, findLastKey, slice, last, mapValues, pickBy} from 'lodash';


export function translateAchievementLevel(level) {
    switch (level) {
        // case 'exploring':
        //     return 'Developing (Exploring)';
        // case 'reliable':
        //     return 'Approaching (Reliable)';
        // case 'proficient':
        //     return 'Applying (Proficient)';
        // case 'exceeding':
        //     return 'Extending (Exceeding)';
        case 'exploring':
            return 'Developing';
        case 'reliable':
            return 'Approaching';
        case 'proficient':
            return 'Applying';
        case 'exceeding':
            return 'Extending';
        case 'goal':
            return 'Goal';
        default:
            return '';
    }
}

function linearRegression(xArray, yArray) {
    let xSum = 0, ySum = 0, xxSum = 0, xySum = 0;
    let count = xArray.length;
    for (let i = 0; i < count; i++) {
        xSum += xArray[i];
        ySum += yArray[i];
        xxSum += xArray[i] * xArray[i];
        xySum += xArray[i] * yArray[i];
    }
    let slope = (count * xySum - xSum * ySum) / (count * xxSum - xSum * xSum);
    let intercept = (ySum / count) - (slope * xSum) / count;
    return { slope: slope, intercept: intercept };
}

export function findAchievement(skills) {
    // const top_level = filter(skills, {achievement_level: 'exceeding'});
    // const uniq_top_level = uniqBy(top_level, 'practice_skill_code');
    // const next_level = filter(skills, {achievement_level: 'proficient'});
    // const uniq_next_level = uniqBy(next_level, 'practice_skill_code');
    // console.log('top_level', top_level);
    // console.log('next_level', next_level);
    

    const top_data = filter(skills, (row) => {
        return row.achievement_level === 'exceeding' || row.achievement_level === 'proficient';
    });
    const uniq_data = uniqBy(
        orderBy(top_data, 'achievement_percentage', 'desc'),
        'practice_skill_code'
    );
    // console.log('uniq_data', uniq_data);

    return {
        top_skills: uniq_data
    }
}

function makeSkillHappy(skill_data) {
    if (!skill_data || skill_data.length < 2) {
        return [];
    };
    // Find best skill
    const max_one = maxBy(skill_data, (s) => s.achievement_percentage);
    const max_key = findLastKey(skill_data, {achievement_percentage: max_one.achievement_percentage});
    if (max_key == 0) {
        return [];
    }
    // Find lowest skill
    const skill_data_left = slice(skill_data, 0, max_key);
    const min_one = minBy(skill_data_left, (s) => s.achievement_percentage);
    const min_key = findKey(skill_data_left, {achievement_percentage: min_one.achievement_percentage});
    if (min_one.achievement_level === max_one.achievement_level) {
        return [];
    }
    // Make min to max happy
    const skill_data_min_to_max = slice(skill_data, min_key, max_key + 1);
    const skill_data_happy = [];
    skill_data_min_to_max.forEach((s) => {
        const last_skill = last(skill_data_happy);
        if (!last_skill || s.achievement_percentage > last_skill.achievement_percentage) {
            skill_data_happy.push(s);
        }
    });
    // Add goal
    if (max_one.achievement_percentage != 100) {
        skill_data_happy.push({
            achievement_percentage: 100,
            achievement_level: 'goal',
            class_date: '2026-07-01'
        });
    }
    return skill_data_happy;
}

export function findDevelopment(skills) {
    const skills_grouped = groupBy(skills, 'practice_skill_id');
    const skills_happified = mapValues(skills_grouped, (s) => makeSkillHappy(s));
    const skills_happy_only = pickBy(skills_happified, (s) => s.length > 1);
    console.log('skills_happy_only', skills_happy_only);
    // return skills_happy_only;
    return skills_grouped;
}

export function graduateProfile(skills) {
    
}

export function findSkillBest(skills, skill_code) {
    const skill_data = filter(skills, {practice_skill_code: skill_code});
    const sorted_skill_data = orderBy(skill_data, 'achievement_percentage', 'desc');
    const skill_best = get(sorted_skill_data, 0);
    if (skill_best) {
        return translateAchievementLevel(skill_best.achievement_level);
    } else {
        return '-';
    }
}